export const VERSION = '1.1.3';
export const M5_SERVER = process.env.REACT_APP_M5_SERVER;
export const M5_SVCID = process.env.REACT_APP_M5_SVC;
export const M5_APIKEY = process.env.REACT_APP_M5_APIKEY;
export const RENDERMODE = process.env.REACT_APP_RENDERMODE;
export const BUCKET_TASK = process.env.REACT_APP_BUCKET_TASK;
export const OAUTH_CLIENT_ID = process.env.REACT_APP_OAUTH_CLIENT_ID;
export const OAUTH_CLIENT_SECRET = process.env.REACT_APP_OAUTH_CLIENT_SECRET;
export const OAUTH_TENANT_ID = process.env.REACT_APP_OAUTH_TENANT_ID;
export const OAUTH_REDIRECT_URI = process.env.REACT_APP_OAUTH_REDIRECT_URI;
export const OAUTH_SCOPES = process.env.REACT_APP_OAUTH_SCOPES;
export const OAUTH_AUTHORITY = process.env.REACT_APP_OAUTH_AUTHORITY;
